import { getWorkflows, updateWorkflow } from "@/services/workflows.svc" 
 
 const defaultState = () => ({
  workflows: [],
  statuses: [
    '1. New Job',
    '2. Need Quote Info',
    '3. Waiting For Approval',
    '4. Materials Needed',
    '5. Approved',
    '6. Done. Need Price',
    '7. Source To Job',
    '8. On Hold',
    '9. Completed'
  ],
  headers: [
    {
      text: 'Job',
      value: 'JobNumber',
      sortable: true,
      print: true,
    },
    {
      text: 'Customer',
      value: 'CustomerName',
      sortable: true,
      print: true,
    },
    {
      text: 'Description',
      value: 'JobDesc',
      sortable: false,
      print: true,
    },
    {
      text: 'PO Number',
      value: 'PoNumber',
      sortable: false,
      print: true,
    },
    {
      text: 'Shipper Number',
      value: 'ShipperNumber',
      sortable: false,
      print: false
    },
    {
      text: 'Start Date',
      value: 'StartDate',
      sortable: true,
      print: true,
    },
    {
      text: 'Finish Date',
      value: 'FinishDate',
      sortable: true,
      print: true
    },
    {
      text: 'Due Date',
      value: 'DueDate',
      sortable: true,
      print: false
    },
    {
      text: 'Status',
      value: 'Status',
      sortable: true,
      print: false,
    },
    {
      text: 'Notes',
      value: 'Notes',
      sortable: false,
      print: false,
    },
    {
      text: 'Actions',
      value: 'actions',
      sortable: false,
      print: false,
    }
  ],
 })
 
 export default {
  namespaced: true,
  state: defaultState(),

  actions: {
    async setWorkflowsAction({ commit }) {
      const data = await getWorkflows()
      commit('SET_WORKFLOWS', data)
    },

    updateWorkflowAction(_, workflow) {
      updateWorkflow(workflow)
    },
  },

  getters: {
    workflows: (state) => state.workflows,
    screenHeaders: (state) => state.headers,
    printHeaders: (state) => state.headers.filter(h => h.print === true),
    statuses: (state) => state.statuses
  },

  mutations: {
    SET_WORKFLOWS(state, payload) {
      state.workflows = payload
    }
  }
 }